import React from "react";

import styles from "./style.module.css";
import tileStyles from "components/Tiles/style.module.css";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import {
  OFFER_TYPE,
  sortOffers,
  executeSearch,
  isOfferPurchased,
  isOfferCreator
} from "containers/Marketplace/reducer";

import { Menu, TypeIcon } from "components/Home/Utils/Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import MarketplaceSelect from "containers/Marketplace/MarketplaceSelect";

import BlueprintTile from "components/Marketplace/Tiles/BlueprintTile";
import MarketplaceDrawer from "components/Marketplace/Drawer/MarketplaceDrawer";

const menuOptions = [
  {
    text: "all"
  },
  {
    text: "blueprints"
  }
];

export default class Marketplace extends React.Component {
  state = {
    selected: "all",
    search: "",
    showDrawer: false,
    selectedItem: null,
    selectedItemType: null
  };

  menuSelectHandler(selected) {
    return this.setState({ selected });
  }

  searchHander(search) {
    return this.setState({ search });
  }

  selectItem(item, type) {
    return this.setState({
      showDrawer: true,
      selectedItem: item,
      selectedItemType: type
    });
  }

  closeDrawer() {
    return this.setState({
      showDrawer: false,
      selectedItem: null,
      selectedItemType: null
    });
  }

  drawerClickHandler(unpublish) {
    const { purchaseBlueprint, unpublishBlueprint } = this.props;
    const { selectedItem, selectedItemType } = this.state;
    switch (selectedItemType) {
      case "blueprint":
        if (unpublish) {
          unpublishBlueprint(selectedItem.id);
        } else {
          purchaseBlueprint(selectedItem.id);
        }
        break;
      default:
    }
    return this.closeDrawer();
  }

  render() {
    const { selectMarketplace, marketplaces, selectedMarketplace, offers, isLoading, userId, history } = this.props;
    const { selected, search, showDrawer } = this.state;
    if (isLoading) {
      return (
        <div className={styles.marketplaceWrapper}>
          <div className={styles.marketplace}>
            <LoadingIndicator />
          </div>
        </div>
      );
    }
    return (
      <div className={styles.marketplaceWrapper}>
        <div className={styles.marketplace}>
          <MarketplaceHeader
            marketplaces={marketplaces}
            selectMarketplace={selectMarketplace}
            selectedMarketplace={selectedMarketplace}
          />
          <Menu
            options={menuOptions}
            selected={selected}
            selectHandler={(value) => this.menuSelectHandler(value)}
            searchHandler={(value) => this.searchHander(value)}
          />
          <div className={styles.marketplaceBodyWrapper}>
            <div className={styles.marketplaceBody + (showDrawer ? " " + styles.showDrawer : "")}>
              <MarketplaceTiles
                {...this.state}
                history={history}
                userId={userId}
                blueprints={sortOffers(OFFER_TYPE.BLUEPRINT, executeSearch(search, offers))}
                selectHandler={(item) => this.selectItem(item, "blueprint")}
              />
            </div>
            <MarketplaceDrawer
              {...this.state}
              userId={userId}
              clickHandler={(unpublish = false) => this.drawerClickHandler(unpublish)}
              closeDrawer={() => this.closeDrawer()}
            />
          </div>
        </div>
      </div>
    );
  }
}

class MarketplaceHeader extends React.PureComponent {
  render() {
    const { marketplaces, selectMarketplace, selectedMarketplace } = this.props;
    return (
      <div className={styles.marketplaceHeaderWrapper}>
        <div className={styles.marketplaceHeader}>
          <div className={styles.marketplaceHeaderTitle}>
            <h1>{selectedMarketplace.title}</h1>
          </div>
          <div className={styles.marketplaceHeaderSelect}>
            <MarketplaceSelect />
          </div>
        </div>
      </div>
    );
  }
}

class MarketplaceTiles extends React.PureComponent {
  render() {
    const { selected, selectHandler, blueprints, selectedItem, selectedItemType, userId, history } = this.props;
    return (
      <React.Fragment>
        {selected === "blueprints" ? (
          <BlueprintTile
            onClick={() => {
              history.push("/blueprint/new");
            }}
            isCreate
          />
        ) : (
          ""
        )}
        {selected === "all" || selected === "blueprints"
          ? blueprints.map((bp) => (
              <BlueprintTile
                key={bp.id}
                onClick={() => selectHandler(bp)}
                blueprint={bp}
                isPurchased={isOfferPurchased(bp)}
                isCreator={isOfferCreator(bp, userId)}
                isHighlight={selectedItemType === "blueprint" && selectedItem && selectedItem.id === bp.id}
              />
            ))
          : ""}
        {selected === "all" && blueprints.length === 0 ? (
          <h1 className={styles.emptyTiles}>Share blueprints with others in your workspace by publishing them</h1>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}
